import React, { useRef, useEffect } from 'react';

const SearchBox = ({
  onChange,
  placeholder = 'Search',
  value = '',
  style = {},
}) => {
  style = { width: '100%', margin: '5px 0', ...style };

  const inputRef = useRef<HTMLAhaSearchFieldElement>();

  const changeValue = value => onChange(value);

  // Clear the search term for use cases where this is not unmounted (i.e., ObjectMenu)
  if (inputRef.current) {
    inputRef.current.value = value;
  }

  // The menu never unmounts, so "autofocus" only works on first open
  // This will focus it on every open
  setTimeout(() => inputRef.current?.focus(), 0);

  useEffect(() => {
    if (inputRef.current) {
      // Prevent typing into the search box from triggering other
      // keyboard shortcuts, except for Escape
      inputRef.current.onkeydown = event => {
        if (event.key !== 'Escape') {
          event.stopPropagation();
        }
      };
      // Prevent search popups from closing on space up. Temp fix while we investigate
      // the root cause
      inputRef.current.onkeyup = event => {
        if (event.code === 'Space') {
          event.stopPropagation();
        }
      };
    }
  }, []);

  return (
    <aha-search-field
      autofocus
      value={value}
      ref={inputRef}
      placeholder={placeholder}
      style={style}
      onInput={event => changeValue(event.target.value)}
      throttled={false}
    />
  );
};

export default SearchBox;
